define([
	"dojo/_base/declare",
	"./OptionalAttributesTable"
], function(declare, OptionalAttributesTable) {

	var CONFIG_CLASS_NAME = "SpecificationItemDefinition";
	var CONFIG_ATTRIBUTE_ID = "ItemDefinitionOptionalAttributes";

	OptionalAttributesTable.watchBooleanValue();

	return declare(OptionalAttributesTable, {
		configNodeType: CONFIG_CLASS_NAME,
		configAttributeId: CONFIG_ATTRIBUTE_ID
	});
});